import { Utils } from '../../fork-common-controls/utils.service';
import { Borrower } from './borrower.interface';
import { GetMortgageBorrower } from '../index';

export class MortgageBorrower implements Borrower {
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  email: string;
  address: string;
  addressUnit: string;
  state: string;
  city: string;
  zipCode: string;
  dob: string;
  phoneNumber: string;
  phoneNumberExt: string;
  phoneType: string;
  occupancyStatus: string;
  paymentAmount: string;
  yearlyIncome: string;
  isActiveDuty: boolean;
  isMilitary: boolean;

  constructor(borrowerResponse: GetMortgageBorrower) {
    this.firstName = borrowerResponse.firstName;
    this.middleName = borrowerResponse.middleName;
    this.lastName = borrowerResponse.lastName;
    this.suffix = borrowerResponse.nameSuffix;
    this.email = borrowerResponse.emailAddress;
    this.addressUnit = borrowerResponse.address.unit;
    this.state = borrowerResponse.address.state;
    this.city = borrowerResponse.address.city;
    this.zipCode = borrowerResponse.address.zipCode;
    this.address = `${borrowerResponse.address.number} ${borrowerResponse.address.street}`;
    this.dob = Utils.getDateString(borrowerResponse.dateOfBirth);
    this.phoneNumber = Utils.formatPhoneNumber(borrowerResponse.phoneNumber);
    this.phoneNumberExt = '';
    this.isActiveDuty = borrowerResponse.isActiveDuty;
    this.isMilitary = borrowerResponse.isMilitary;
  }
}
